import { useEffect, useState } from 'react';

export const useHeroImage = ({ image, mobile_image, slides }) => {
  const [heroImage, setHeroImage] = useState(slides ? slides.map(({ image }) => image) : image);


  const handleResize = () => {
    if (slides) {
      setHeroImage(slides.map(({ image, mobile_image }) => window.innerWidth < 768 ? mobile_image || image : image));
    } else {
      setHeroImage(window.innerWidth < 768 ? mobile_image || image : image);
    }
  };

  useEffect(() => {
    try {
      if (window) {
        if (slides) {
          setHeroImage(slides.map(({ image, mobile_image }) => window.innerWidth < 768 ? mobile_image || image : image));
        } else {
          setHeroImage(window.innerWidth < 768 ? mobile_image || image : image);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  return { heroImage, setHeroImage };
};
